import { render, staticRenderFns } from "./PageConnectWithOtherDoctor.vue?vue&type=template&id=39641b54"
import script from "./PageConnectWithOtherDoctor.vue?vue&type=script&lang=js"
export * from "./PageConnectWithOtherDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports